import { CART_TRACKER_TYPE_FOR_V1_AND_V2 } from '../../../../shop/constants/tracker';
import { getInjector } from '../../utils/getInjector';

export const onTrackPaymentOptionClick = async () => {
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');

  trackerService.track({
    type: CART_TRACKER_TYPE_FOR_V1_AND_V2.PAYMENT_OPTION_CLICK,
    data: {
      event_category: 'Cart',
    },
  });
};
